import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSystemAnnouncements } from '../../contexts/SystemAnnouncementsContext';

export default function AnnouncementBell() {
  const value = useSystemAnnouncements();
  const { t } = useTranslation();
  if (!value?.enabled) return null;
  const { unreadCount, loaded } = value;
  const label = unreadCount === null ? t('announcements.title') : t('announcements.unreadLabel', { count: unreadCount });
  return (
    <Link to="/announcements" aria-label={label} title={loaded && unreadCount === null ? t('announcements.refreshCount') : label}
      className="relative inline-flex shrink-0 items-center justify-center rounded p-2 text-white hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-white">
      <Bell size={20} aria-hidden="true" />
      {unreadCount > 0 && <span aria-hidden="true" className="absolute -right-1 -top-1 rounded-full bg-red-600 px-1.5 text-xs font-semibold">{unreadCount > 99 ? '99+' : unreadCount}</span>}
      <span className="sr-only" role="status">{label}{loaded && unreadCount === null ? ` — ${t('announcements.refreshCount')}` : ''}</span>
    </Link>
  );
}
